{
  "2013_cfs_p10_v1.png": [
    407,
    256
  ],
  "2013_cfs_p10_v2.png": [
    516,
    336
  ],
  "2013_cfs_p11_v1.png": [
    614,
    375
  ],
  "2013_cfs_p11_v2.png": [
    512,
    466
  ],
  "2013_cfs_p12_v3.png": [
    640,
    328
  ],
  "2013_cfs_p13_1.png": [
    774,
    230
  ],
  "2013_cfs_p13_v1.png": [
    676,
    393
  ],
  "2014_cfs_p07_1.png": [
    791,
    889
  ],
  "2014_cfs_p10_v1.png": [
    460,
    496
  ],
  "2014_cfs_p11_v3.png": [
    571,
    390
  ],
  "2014_cfs_p13_v3.png": [
    426,
    314
  ],
  "2015_cfs1_p07_1.png": [
    591,
    515
  ],
  "2015_cfs1_p08_1.png": [
    143,
    86
  ],
  "2015_cfs1_p08_2.png": [
    143,
    86
  ],
  "2015_cfs2_p08_v1.png": [
    283,
    282
  ],
  "2015_cfs2_p13_1.png": [
    537,
    258
  ],
  "2015_cfs2_p13_2.png": [
    773,
    363
  ],
  "2015_cfs2_p14_v1.png": [
    354,
    322
  ],
  "2016_cfs1_p06_1.png": [
    653,
    510
  ],
  "2016_cfs1_p07_1.png": [
    457,
    362
  ],
  "2016_cfs1_p07_2.png": [
    358,
    262
  ],
  "2016_cfs1_p12_2.png": [
    135,
    168
  ],
  "2016_cfs1_p12_3.png": [
    142,
    154
  ],
  "2016_cfs1_p12_4.png": [
    449,
    247
  ],
  "2016_cfs1_p13_1.png": [
    291,
    406
  ],
  "2016_cfs1_p13_2.png": [
    164,
    163
  ],
  "2016_cfs2_p05_1.png": [
    731,
    509
  ],
  "2016_cfs2_p05_2.png": [
    751,
    230
  ],
  "2016_cfs2_p07_1.png": [
    175,
    218
  ],
  "2016_cfs2_p07_2.png": [
    344,
    296
  ],
  "2016_cfs2_p10_1.png": [
    554,
    267
  ],
  "2016_cfs2_p10_2.png": [
    680,
    307
  ],
  "2016_cfs2_p11_2.png": [
    119,
    190
  ],
  "2016_cfs2_p11_4.png": [
    246,
    101
  ],
  "2016_cfs2_p12_1.png": [
    259,
    434
  ],
  "2017_cfs2_p11_1.png": [
    366,
    288
  ],
  "2017_cfs2_p12_1.png": [
    773,
    504
  ],
  "2017_cfs2_p12_2.png": [
    680,
    411
  ],
  "2018_cfs1_p10_v2.png": [
    479,
    341
  ],
  "2018_cfs1_p11_1.png": [
    407,
    224
  ],
  "2018_cfs1_p11_2.png": [
    286,
    232
  ],
  "2018_cfs1_p11_3.png": [
    309,
    164
  ],
  "2018_cfs1_p12_v1.png": [
    477,
    260
  ],
  "2018_cfs2_p09_2.png": [
    407,
    45
  ],
  "2018_cfs2_p10_1.png": [
    436,
    179
  ],
  "2018_cfs2_p13_1.png": [
    541,
    256
  ],
  "2019_cfs_p12_1.png": [
    523,
    171
  ],
  "2019_cfs_p12_2.png": [
    359,
    188
  ],
  "2019_cfs_p13_3.png": [
    558,
    248
  ],
  "2019_cfs_p14_1.png": [
    428,
    173
  ],
  "2020_cfs1_p11_1.png": [
    557,
    248
  ],
  "2020_cfs1_p11_3.png": [
    359,
    188
  ],
  "2020_cfs1_p13_1.png": [
    428,
    173
  ],
  "2020_cfs1_p14_1.png": [
    523,
    171
  ],
  "2020_cfs2_p08_1.png": [
    406,
    308
  ],
  "2020_cfs2_p08_2.png": [
    329,
    215
  ],
  "2020_cfs2_p09_2.png": [
    416,
    249
  ],
  "2020_cfs2_p09_3.png": [
    452,
    261
  ],
  "2020_cfs2_p09_4.png": [
    401,
    201
  ],
  "2020_cfs2_p10_2.png": [
    365,
    281
  ],
  "2020_cfs2_p12_1.png": [
    398,
    257
  ],
  "2020_cfs2_p12_2.png": [
    553,
    287
  ],
  "2020_cfs2_p13_3.png": [
    423,
    328
  ],
  "2020_cfs2_p14_1.png": [
    784,
    252
  ],
  "2020_cfs2_p14_2.png": [
    291,
    154
  ],
  "2020_cfs2_p14_3.png": [
    291,
    157
  ],
  "2020_cfs2_p14_4.png": [
    291,
    154
  ],
  "2020_cfs2_p14_5.png": [
    290,
    154
  ],
  "2021_cfs1_p05_1.png": [
    178,
    293
  ],
  "2021_cfs1_p05_2.png": [
    818,
    202
  ],
  "2021_cfs1_p07_1.png": [
    683,
    201
  ],
  "2021_cfs1_p09_3.png": [
    440,
    95
  ],
  "2021_cfs1_p10_2.png": [
    214,
    141
  ],
  "2021_cfs1_p11_1.png": [
    610,
    429
  ],
  "2021_cfs1_p11_2.png": [
    494,
    93
  ],
  "2021_cfs1_p12_1.png": [
    577,
    390
  ],
  "2021_cfs1_p12_2.png": [
    775,
    226
  ],
  "2021_cfs1_p12_3.png": [
    192,
    48
  ],
  "2021_cfs1_p14_2.png": [
    506,
    428
  ],
  "2021_cfs1_p16_3.png": [
    377,
    463
  ],
  "2021_cfs2_p06_1.png": [
    647,
    568
  ],
  "2021_cfs2_p07_1.png": [
    805,
    252
  ],
  "2021_cfs2_p08_1.png": [
    171,
    309
  ],
  "2021_cfs2_p10_1.png": [
    235,
    222
  ],
  "2021_cfs2_p13_1.png": [
    451,
    231
  ],
  "2021_cfs2_p14_1.png": [
    512,
    309
  ],
  "2021_cfs2_p17_1.png": [
    334,
    338
  ],
  "2022_cfs1_p10_1.png": [
    253,
    244
  ],
  "2022_cfs1_p10_2.png": [
    364,
    330
  ],
  "2022_cfs1_p11_1.png": [
    248,
    253
  ],
  "2022_cfs1_p13_1.png": [
    671,
    309
  ],
  "2022_cfs1_p16_2.png": [
    613,
    466
  ],
  "2022_cfs2_p06_1.png": [
    790,
    246
  ],
  "2022_cfs2_p07_1.png": [
    683,
    358
  ],
  "2022_cfs2_p07_2.png": [
    581,
    580
  ],
  "2022_cfs2_p08_1.png": [
    381,
    378
  ],
  "2022_cfs2_p09_1.png": [
    775,
    233
  ],
  "2022_cfs2_p09_2.png": [
    400,
    386
  ],
  "2022_cfs2_p09_3.png": [
    292,
    301
  ],
  "2022_cfs2_p10_1.png": [
    299,
    293
  ],
  "2022_cfs2_p10_2.png": [
    397,
    369
  ],
  "2022_cfs2_p12_1.png": [
    573,
    413
  ],
  "2022_cfs2_p12_2.png": [
    282,
    353
  ],
  "2022_cfs2_p12_3.png": [
    568,
    284
  ],
  "2022_cfs2_p15_1.png": [
    495,
    291
  ],
  "2022_cfs2_p16_4.png": [
    383,
    366
  ],
  "2022_cfs2_p17_2.png": [
    679,
    304
  ],
  "2022_cfs2_p17_3.png": [
    796,
    346
  ],
  "2023_cfs1_p09_1.png": [
    233,
    354
  ],
  "2023_cfs1_p10_1.png": [
    430,
    298
  ],
  "2023_cfs1_p10_2.png": [
    238,
    242
  ],
  "2023_cfs1_p14_1.png": [
    475,
    311
  ],
  "2023_cfs1_p15_1.png": [
    338,
    341
  ],
  "2023_cfs2_p07_1.png": [
    692,
    373
  ],
  "2023_cfs2_p08_1.png": [
    758,
    688
  ],
  "2023_cfs2_p08_2.png": [
    735,
    615
  ],
  "2023_cfs2_p09_1.png": [
    357,
    293
  ],
  "2023_cfs2_p12_1.png": [
    565,
    469
  ],
  "2023_cfs2_p13_1.png": [
    589,
    338
  ],
  "2023_cfs2_p14_1.png": [
    200,
    238
  ],
  "2023_cfs2_p15_1.png": [
    529,
    203
  ],
  "2023_cfs2_p15_2.png": [
    334,
    338
  ],
  "2024_cfs1_p08_1.png": [
    368,
    317
  ],
  "2024_cfs1_p08_2.png": [
    414,
    267
  ],
  "2024_cfs1_p08_3.png": [
    722,
    318
  ],
  "2024_cfs1_p10_1.png": [
    258,
    224
  ],
  "2024_cfs1_p10_3.png": [
    200,
    203
  ],
  "2024_cfs1_p10_4.png": [
    631,
    492
  ],
  "2024_cfs1_p11_1.png": [
    465,
    274
  ],
  "2024_cfs1_p12_2.png": [
    345,
    336
  ],
  "2024_cfs1_p13_3.png": [
    373,
    225
  ],
  "2024_cfs1_p13_5.png": [
    316,
    251
  ],
  "2024_cfs1_p13_6.png": [
    506,
    294
  ],
  "2024_cfs1_p14_1.png": [
    359,
    221
  ],
  "2024_cfs2_p08_1.png": [
    360,
    423
  ],
  "2024_cfs2_p09_v1.png": [
    554,
    436
  ],
  "2024_cfs2_p10_1.png": [
    283,
    404
  ],
  "2024_cfs2_p12_1.png": [
    427,
    280
  ],
  "2024_cfs2_p12_6.png": [
    403,
    163
  ],
  "2024_cfs2_p13_4.png": [
    403,
    293
  ],
  "2024_cfs2_p14_1.png": [
    605,
    167
  ],
  "2024_cfs2_p14_2.png": [
    313,
    253
  ],
  "2024_cfs2_p14_7.png": [
    482,
    408
  ],
  "2025_cfs1_p07_1.png": [
    312,
    372
  ],
  "2025_cfs1_p10_2.png": [
    490,
    270
  ],
  "2025_cfs1_p11_2.png": [
    283,
    230
  ],
  "2025_cfs1_p11_3.png": [
    438,
    296
  ],
  "2025_cfs1_p12_2.png": [
    491,
    292
  ],
  "2025_cfs1_p12_3.png": [
    507,
    184
  ],
  "2025_cfs1_p13_1.png": [
    758,
    242
  ],
  "2025_cfs2_p05_1.png": [
    307,
    39
  ],
  "2025_cfs2_p05_2.png": [
    316,
    43
  ],
  "2025_cfs2_p06_2.png": [
    281,
    277
  ],
  "2025_cfs2_p06_4.png": [
    259,
    41
  ],
  "2025_cfs2_p08_1.png": [
    415,
    412
  ],
  "2025_cfs2_p09_1.png": [
    524,
    190
  ],
  "2025_cfs2_p10_2.png": [
    460,
    314
  ],
  "2025_cfs2_p11_1.png": [
    546,
    337
  ],
  "fig-2020-q1.webp": [
    1500,
    607
  ],
  "fig-2020-q25.webp": [
    1000,
    1072
  ],
  "fig-2020-q29.webp": [
    1500,
    724
  ],
  "fig-2020-q4.webp": [
    950,
    830
  ],
  "fig-2021-q26.webp": [
    900,
    1331
  ],
  "fig-2022-q17.webp": [
    1000,
    575
  ],
  "fig-2023-q17.webp": [
    1000,
    581
  ],
  "fig-2025-q17.webp": [
    1472,
    712
  ],
  "fig-2025-q18.webp": [
    824,
    588
  ],
  "tira-2021-t4.webp": [
    1332,
    344
  ],
  "tira-2022-t2.webp": [
    1500,
    468
  ],
  "tira-2023-t2.webp": [
    1500,
    480
  ],
  "tira-2023-t3.webp": [
    1000,
    1078
  ]
}
